import { Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import { extractAnchorsFromText } from 'config/libs/helpers'
import { ImageHeadlineTextFiftyFiftyType } from 'types'
import DCAImage from 'components/DCAImage'
import useNavigation from 'hooks/useNavigation'

type ImageHeadlineTextFiftyFiftyProps = {
  layoutData: ImageHeadlineTextFiftyFiftyType
}

const ImageHeadlineTextFiftyFifty = ({ layoutData }: ImageHeadlineTextFiftyFiftyProps) => {
  const { image, headline, text } = layoutData

  const { onDynamicNavigate } = useNavigation()

  const textWithAnchors = extractAnchorsFromText(text ?? '')

  const onGoNextPage = (pageId: number) => {
    if (!pageId) return

    onDynamicNavigate(pageId)
  }

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      const clickedElement = event.target as HTMLElement

      if (clickedElement.classList.contains('dca-anchor')) {
        event.preventDefault()

        const anchorDataID = clickedElement.getAttribute('data-id')

        if (anchorDataID) {
          onGoNextPage(Number(anchorDataID))
        } else {
          const anchorURL = clickedElement.getAttribute('href')
          if (anchorURL) {
            onGoNextPage(Number(anchorURL))
          }
        }
      }
    }

    document.addEventListener('click', clickHandler)

    return () => {
      document.removeEventListener('click', clickHandler)
    }
  }, [])

  return (
    <Container className='image-fifty-fifty-wrapper pt-4'>
      <Row>
        <Col md='6' xs='6' className='px-4'>
          {image && <DCAImage src={image} type='lazyImage' className='w-100' />}
        </Col>
        <Col md='6' xs='6' className='mr-2'>
          {headline && (
            <h5
              className='ak-bold'
              dangerouslySetInnerHTML={{
                __html: headline,
              }}
            />
          )}
          <p
            dangerouslySetInnerHTML={{
              __html: textWithAnchors,
            }}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default ImageHeadlineTextFiftyFifty
